import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { CRUD } from '../interfaces/crud.interface';
import { Count } from '../interfaces/count.interface';
import 'rxjs/add/observable/empty';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class RegulationsService implements CRUD<object> {
  public directorySubject = new BehaviorSubject<string>('');
  public directory$ = this.directorySubject.asObservable();

  static b64toBlob(b64Data: string, contentType: string): any {
    const bytesPackageSize = 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += bytesPackageSize) {
      const slice = byteCharacters.slice(offset, offset + bytesPackageSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: contentType });
  }

  constructor(private http: HttpClient) {}

  findAll(query: any, pageIndex: number, pageSize: number): Observable<object[]> {
    return this.http.get<any[]>(
      `${environment.FILES_API_URL}?directory=${query.directory}&name=${query.name}&pageIndex=${pageIndex}&pageSize=${pageSize}`
    );
  }

  findById(id: string): Observable<any> {
    return this.http.get<{ data: string; type: string }>(
      `${environment.FILES_API_URL}/single?fileKey=${encodeURIComponent(id)}`
    );
  }

  create(data: object): Observable<object> {
    return Observable.empty<object>();
  }

  update(id: string, data: object): Observable<object> {
    return Observable.empty<object>();
  }

  remove(fileKey: string): Observable<object> {
    return this.http.delete<any>(`${environment.FILES_API_URL}?fileKey=${fileKey}`);
  }

  count(query: any): Observable<Count> {
    return this.http.get<Count>(`${environment.FILES_API_URL}/count?directory=${query.directory}&name=${query.name}`);
  }

  changeBucketFolder(body): Observable<void> {
    return this.http.post<void>(`${environment.FILES_API_URL}/change-folder`, { names: body });
  }

  removeManyFiles(files: string[]): Observable<void> {
    const params = {
      headers: {
        contentType: 'application/json'
      },
      body: files
    };
    return this.http.delete<void>(`${environment.FILES_API_URL}/remove-files`, params);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/regulations.service.ts